<template>
    <modal name="document-loading-modal"
        :adaptive="true"
        :focusTrap="true"
        :width="500"
        height="auto"
        :styles="{ boxShadow: 'none', background: 'transparent' }"
    >
        <div class="rounded-lg bg-white p-6">
            <div class="flex py-10 text-xl justify-center items-center text-blue-600">
                <spinner class="w-8 h-8 mr-4" />

                Connecting to DocuSign ...
            </div>
        </div>
    </modal>
</template>

<script>
import Spinner from '../../../components/spinner.vue';

export default {
    components: {
        Spinner,
    },

    props: {
        show: {},
    },

    watch: {
        show(val) {
            if (val) {
                this.$modal.show('document-loading-modal');
            } else {
                this.$modal.hide('document-loading-modal');
            }
        },
    },
}
</script>

<style scoped>
.vm--overlay {
    background: #000000;
    opacity: 0.7;
}

.overlay-enter,
.overlay-leave-to {
    opacity: 0;
}

.overlay-enter-active,
.overlay-leave-active {
    transition: all .3s;
}
</style>
